import { render, staticRenderFns } from "./sustainability.vue?vue&type=template&id=b34386ca&scoped=true&"
import script from "./sustainability.vue?vue&type=script&lang=js&"
export * from "./sustainability.vue?vue&type=script&lang=js&"
import style0 from "./sustainability.vue?vue&type=style&index=0&id=b34386ca&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34386ca",
  null
  
)

export default component.exports